module.exports = __webpack_public_path__ + "img/users-selected.3751c5e8.svg";